import { MeterColumn } from '@contracts';
export const DEFAULT_ENERGY_METER_COLUMNS: MeterColumn[] = [
  {
    key: 'no',
    order: 10,
    label: 'view_value.no',
    type: 'text',
    sortable: false,
    visible: true,
    exportable: true,
    valueGetter: (_row, index, pageIndex, pageSize) =>
      pageIndex * pageSize + index + 1,
  },
  {
    key: 'module',
    order: 20,
    label: 'view_value.module',
    field: 'module',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'name',
    order: 30,
    label: 'view_value.meter_name',
    field: 'name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'type',
    order: 40,
    label: 'view_value.sensor_type',
    field: 'type',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'last_active_at',
    order: 50,
    label: 'view_value.last_active',
    field: 'last_active_at',
    type: 'datetime',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'location_tier_5',
    order: 60,
    label: 'view_value.location_tier_5',
    field: 'location_tier_5',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'status',
    order: 70,
    label: 'view_value.status',
    field: 'status',
    type: 'status',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'kwh',
    order: 80,
    label: 'view_value.kwh',
    field: 'kwh',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'v_p1',
    order: 90,
    label: 'view_value.v_p1',
    field: 'v_p1',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'v_p2',
    order: 100,
    label: 'view_value.v_p2',
    field: 'v_p2',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'v_p3',
    order: 110,
    label: 'view_value.v_p3',
    field: 'v_p3',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'i_1',
    order: 120,
    label: 'view_value.i_1',
    field: 'i_1',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'i_2',
    order: 130,
    label: 'view_value.i_2',
    field: 'i_2',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'i_3',
    order: 140,
    label: 'view_value.i_3',
    field: 'i_3',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'kw',
    order: 150,
    label: 'view_value.kw',
    field: 'kw',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 2,
      maxFractionDigits: 2,
    },
  },
  {
    key: 'conv_ip',
    order: 160,
    label: 'view_value.conv_ip',
    field: 'conv_ip',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'port',
    order: 170,
    label: 'view_value.port',
    field: 'port',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'meter_id',
    order: 180,
    label: 'view_value.meter_id',
    field: 'meter_id',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'loop_name',
    order: 190,
    label: 'view_value.loop_name',
    field: 'loop_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'brand_name',
    order: 200,
    label: 'view_value.brand_name',
    field: 'brand_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'tags',
    order: 210,
    label: 'view_value.tag',
    field: 'tags',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'tenant_name',
    order: 220,
    label: 'view_value.shop_name',
    field: 'tenant_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'manage',
    order: 1000,
    label: 'view_value.manage',
    type: 'action',
    sortable: false,
    visible: true,
    exportable: false,
  },
];
